"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _TextButtonIcon = require("../TextButtonIcon/TextButtonIcon");
var _TextButton = require("./TextButton.styles");
var _excluded = ["children", "icon", "iconPosition", "iconSize"];
/**
 * Renders a basic
 * [HTML button element](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button).
 *
 * While the styling of a text button resembles that of an `Anchor`, text buttons are
 * generally used for user actions and not for navigation. If you need to use a text button for
 * navigation and a regular `Anchor` does not suffice, make sure to set `as="a"` to help
 * assistive technologies better represent the purpose of the component.
 *
 * @since 5.0.0
 */
var TextButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
    icon = _ref.icon,
    iconPosition = _ref.iconPosition,
    iconSize = _ref.iconSize,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var startIcon;
  if (iconPosition === 'start' && icon) {
    startIcon = /*#__PURE__*/_react.default.createElement(_TextButtonIcon.TextButtonIcon, {
      iconPosition: iconPosition,
      iconSize: iconSize
    }, icon);
  }
  var endIcon;
  if (iconPosition === 'end' && icon) {
    endIcon = /*#__PURE__*/_react.default.createElement(_TextButtonIcon.TextButtonIcon, {
      iconPosition: iconPosition,
      iconSize: iconSize
    }, icon);
  }
  return /*#__PURE__*/_react.default.createElement(_TextButton.StyledTextButton, (0, _extends2.default)({
    ref: forwardedRef
  }, rest), startIcon, children, endIcon);
});
exports.TextButton = TextButton;
TextButton.displayName = 'TextButton';
TextButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The styled-components
   * [polymorphic "as"](https://styled-components.com/docs/api#as-polymorphic-prop) prop.
   *
   * By default, this is a basic `<button>` element, but if you are using this component for
   * navigation, you should set this to `as="a"`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any,
  /** The type of the button. */
  buttonType: _propTypes.default.oneOf(Object.values(_constants.TEXT_BUTTON_TYPES)),
  /**
   * Text button content.
   */
  children: _propTypes.default.node,
  /** Set the button as disabled. */
  disabled: _propTypes.default.bool,
  /**
   * Determines the font used for the label. Limited to `body`, `bodyHeading`, `bodySmall` and
   * `bodySmallHeading`.
   */
  fontType: _propTypes.default.oneOf(Object.values(_constants.TEXT_BUTTON_FONT_TYPES)),
  /**
   * Add an `Icon` to the button.
   */
  icon: _propTypes.default.node,
  /**
   * Change the position of the `icon`.
   */
  iconPosition: _propTypes.default.oneOf(['start', 'end']),
  /**
   * This is not an exposed API property. It is only used internally.
   *
   * @ignore
   */
  iconSize: _propTypes.default.string,
  /** For use on dark or colored backgrounds. */
  inverse: _propTypes.default.bool
} : {};
TextButton.defaultProps = {
  as: 'button',
  buttonType: _constants.TEXT_BUTTON_TYPES.primary,
  disabled: undefined,
  fontType: 'bodyHeading',
  inverse: false,
  iconPosition: 'start',
  iconSize: 'sm'
};